import { gql, TypedDocumentNode } from '@apollo/client';

import {
  UpdateUserSecretMutation,
  UpdateUserSecretMutationVariables,
} from '../generated';

export const UPDATE_USER_SECRET: TypedDocumentNode<
  UpdateUserSecretMutation,
  UpdateUserSecretMutationVariables
> = gql`
  mutation UpdateUserSecret($input: UpdateUserSecretInput!) {
    updateUserSecret(input: $input) {
      id
      key
      description
      createdAt
      updatedAt
    }
  }
`;
